import RegisterField, { FieldProps } from "../register-field";
import { ModelComboBox, ModelComboBoxProps } from "@/components/inputs";
import { BaseQuery } from "@/shared/types/base";

export default function FormModelComboBox<T extends ({ id: string } & Record<string, any>), P extends BaseQuery>({
    name,
    registerOptions,
    ...props
}: FieldProps<ModelComboBoxProps<T, P>>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <ModelComboBox
            {...props}

            ref={field.ref}
            value={field.value}
            disabled={field.disabled}

            setValue={v => {
                field.handleChange(v);
                props.setValue && props.setValue(v);
            }}
            onObjectSelected={obj => {
                props.onObjectSelected && props.onObjectSelected(obj);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}